/** Send a low-stock email when quantity is at or below threshold and just crossed that line. */
export function shouldNotifyLowStock(
  quantity: number,
  threshold: number,
  previousQuantity?: number
): boolean {
  if (threshold <= 0 || quantity > threshold) {
    return false;
  }
  if (previousQuantity === undefined) {
    return true;
  }
  return previousQuantity > threshold;
}
